/* MEN & PANDA — interactions. Vanilla, aucune dépendance. */

(function () {
  'use strict';

  /* --- Modalité d'entrée ---
     On ne rend le focus à un déclencheur que si l'utilisateur navigue au
     clavier. Rendu après un clic souris, il dessine l'anneau de focus — un
     liseré noir autour de la photo, que le visiteur lit comme un défaut
     d'affichage puisqu'il n'a jamais quitté sa souris. Le clavier, lui, en a
     besoin : sans ce retour, la tabulation repartirait du début de la page. */
  var auClavier = false;

  document.addEventListener('keydown', function (event) {
    if (['Tab', 'Escape', 'Enter', ' ', 'ArrowLeft', 'ArrowRight'].indexOf(event.key) !== -1) {
      auClavier = true;
    }
  }, true);

  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function () { auClavier = false; }, true);
  });

  /* --- Hauteur réelle de l'en-tête ---
     Le décalage du contenu et la position de la nav latérale en dépendent.
     Elle varie selon que le bandeau d'annonce est présent, absent, ou refermé,
     et selon que son texte tient sur une ou deux lignes. */
  function measureHeader() {
    var group = document.querySelector('.header-group') || document.querySelector('.header');
    var announcement = document.querySelector('.announcement');
    var root = document.documentElement;

    if (group) {
      root.style.setProperty('--header-height', group.offsetHeight + 'px');
    }

    // En desktop, l'en-tête n'est PAS une barre horizontale : c'est la colonne
    // de gauche. Le contenu ne doit donc être décalé que de la hauteur du
    // bandeau d'annonce, pas de celle de tout l'en-tête.
    root.style.setProperty(
      '--announcement-height',
      (announcement ? announcement.offsetHeight : 0) + 'px'
    );
  }

  /* --- Escamotage du bandeau d'annonce ---
     Il disparaît dès qu'on descend et revient une fois revenu tout en haut. */
  function watchAnnouncement() {
    var group = document.querySelector('.header-group');
    if (!group || !document.querySelector('.announcement')) return;

    var SEUIL = 60;
    var ticking = false;

    function update() {
      ticking = false;
      group.classList.toggle('header-group--compact', window.scrollY > SEUIL);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }

  function watchHeaderHeight() {
    measureHeader();
    window.addEventListener('resize', measureHeader);
    document.addEventListener('announcement:closed', measureHeader);

    // Les polices system-ui se posent après le premier rendu : on remesure.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measureHeader);
    }
  }

  /* --- Navigation : accordéon + panneau mobile --- */
  function initNav() {
    var nav = document.querySelector('[data-nav]');
    var toggle = document.querySelector('[data-nav-toggle]');

    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.dataset.open === 'true';
        nav.dataset.open = String(!open);
        toggle.setAttribute('aria-expanded', String(!open));
        document.body.style.overflow = open ? '' : 'hidden';
      });
    }

    document.querySelectorAll('[data-panel-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;

        var open = panel.dataset.open === 'true';

        // Un seul panneau ouvert à la fois
        document.querySelectorAll('.nav__panel').forEach(function (other) {
          other.dataset.open = 'false';
        });
        document.querySelectorAll('[data-panel-toggle]').forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
        });

        panel.dataset.open = String(!open);
        button.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* --- Visionneuse plein écran (zoom produit) --- */
  function initZoom() {
    var zoom = document.querySelector('[data-zoom]');
    if (!zoom) return;

    var images = zoom.querySelectorAll('[data-zoom-image]');
    var compteur = zoom.querySelector('[data-zoom-current]');
    var stage = zoom.querySelector('[data-zoom-stage]');
    if (!images.length) return;

    var index = 0;
    var declencheur = null;
    // Modalité retenue À L'OUVERTURE, et non à la fermeture : fermer avec Échap
    // après avoir cliqué à la souris basculerait sinon en « clavier » et
    // ramènerait l'anneau. C'est la façon d'ENTRER dans la visionneuse qui dit
    // si le visiteur navigue au clavier, pas celle d'en sortir.
    var ouvertAuClavier = false;
    // Boîte de l'image AVANT agrandissement. Indispensable : une fois l'image
    // mise à l'échelle, getBoundingClientRect renvoie la boîte agrandie, et
    // calculer la position du curseur dessus ferait dériver le cadrage.
    var boiteNette = null;
    var echelle = 1;
    var tx = 0;
    var ty = 0;
    var glisse = null;   // point de départ d'un glissement au doigt

    function afficher(i) {
      index = (i + images.length) % images.length;

      images.forEach(function (img, n) {
        img.hidden = n !== index;
        // Sortir une image de l'écran doit aussi annuler son agrandissement.
        img.classList.remove('zoom__image--magnified', 'zoom__image--panning');
      });
      boiteNette = null;
      echelle = 1;
      tx = ty = 0;
      glisse = null;

      if (compteur) compteur.textContent = String(index + 1);
    }

    function ouvrir(i, source) {
      declencheur = source || null;
      ouvertAuClavier = auClavier;
      afficher(i);
      // Les voisines sont préparées pour que les flèches n'attendent pas non plus.
      precharger(i + 1);
      precharger(i - 1);
      zoom.hidden = false;
      document.body.classList.add('zoom-open');

      var premier = zoom.querySelector('[data-zoom-close]');
      if (premier) premier.focus();
    }

    function fermer() {
      zoom.hidden = true;
      document.body.classList.remove('zoom-open');
      // Retour du focus réservé au clavier : voir la note sur ouvertAuClavier.
      if (declencheur && ouvertAuClavier) declencheur.focus();
    }

    // Préchargement. Les images du zoom sont masquées dans un conteneur lui-même
    // masqué : le navigateur ne les télécharge donc jamais d'avance, et le clic
    // ouvrait une visionneuse vide le temps du chargement. On réchauffe le cache
    // AVANT le clic — au survol, à la prise de focus, ou au premier contact.
    var prechargees = {};

    function precharger(i) {
      if (prechargees[i] || !images[i]) return;
      prechargees[i] = true;
      var p = new Image();
      p.src = images[i].getAttribute('src');
    }

    document.querySelectorAll('[data-zoom-open]').forEach(function (bouton) {
      var i = Number(bouton.dataset.zoomOpen);

      ['mouseenter', 'focus', 'touchstart'].forEach(function (evt) {
        bouton.addEventListener(evt, function () { precharger(i); }, { passive: true });
      });

      bouton.addEventListener('click', function () {
        ouvrir(i, bouton);
      });
    });

    // La première image est préchargée dès que le navigateur est disponible :
    // c'est celle qu'on ouvre presque toujours, et l'attente y est la plus
    // visible. Les autres suivent au survol de leur propre déclencheur.
    if (window.requestIdleCallback) {
      requestIdleCallback(function () { precharger(0); });
    } else {
      setTimeout(function () { precharger(0); }, 1200);
    }

    var fermeture = zoom.querySelector('[data-zoom-close]');
    if (fermeture) fermeture.addEventListener('click', fermer);

    var prev = zoom.querySelector('[data-zoom-prev]');
    var next = zoom.querySelector('[data-zoom-next]');
    if (prev) prev.addEventListener('click', function () { afficher(index - 1); });
    if (next) next.addEventListener('click', function () { afficher(index + 1); });

    // Déplacement maximal : au-delà, le cadre découvrirait du vide. L'image
    // agrandie mesure echelle x boiteNette ; le cadre visible est la scène.
    function bornes() {
      var cadre = stage.getBoundingClientRect();
      return {
        x: Math.max(0, (boiteNette.width * echelle - cadre.width) / 2),
        y: Math.max(0, (boiteNette.height * echelle - cadre.height) / 2)
      };
    }

    function appliquer(img) {
      var b = bornes();
      tx = Math.max(-b.x, Math.min(b.x, tx));
      ty = Math.max(-b.y, Math.min(b.y, ty));
      img.style.setProperty('--zoom-tx', tx.toFixed(1) + 'px');
      img.style.setProperty('--zoom-ty', ty.toFixed(1) + 'px');
    }

    // Souris : la position du curseur désigne la zone à regarder.
    function viser(point, img) {
      if (!boiteNette) return;
      var b = bornes();
      var u = (point.clientX - boiteNette.left) / boiteNette.width;
      var v = (point.clientY - boiteNette.top) / boiteNette.height;
      tx = (0.5 - Math.max(0, Math.min(1, u))) * b.x * 2;
      ty = (0.5 - Math.max(0, Math.min(1, v))) * b.y * 2;
      appliquer(img);
    }

    function reduire(img) {
      img.classList.remove('zoom__image--magnified', 'zoom__image--panning');
      boiteNette = null;
      echelle = 1;
      tx = ty = 0;
      glisse = null;
    }

    function agrandir(point, img) {
      boiteNette = img.getBoundingClientRect();

      // On agrandit jusqu'à la résolution native du fichier, et pas au-delà :
      // pousser plus loin n'ajoute aucun détail, cela ne fait qu'étirer des
      // pixels. Plafonné à 3x, et jamais moins de 1,6x sans quoi le geste
      // paraîtrait sans effet.
      var natif = img.naturalWidth / boiteNette.width;
      echelle = Math.max(1.6, Math.min(natif, 3));
      img.style.setProperty('--zoom-scale', echelle.toFixed(2));

      // Le cadrage est posé AVANT la classe : l'agrandissement s'anime alors
      // vers le bon point au lieu de partir du centre puis sauter.
      viser(point, img);
      img.classList.add('zoom__image--magnified');
    }

    stage.addEventListener('click', function (event) {
      var img = event.target.closest('[data-zoom-image]');
      if (!img) return;
      if (img.classList.contains('zoom__image--magnified')) reduire(img);
      else agrandir(event, img);
    });

    stage.addEventListener('mousemove', function (event) {
      var img = images[index];
      if (!img || !img.classList.contains('zoom__image--magnified')) return;
      img.classList.add('zoom__image--panning');
      viser(event, img);
    });

    /* --- Tactile --- */
    stage.addEventListener('touchstart', function (event) {
      var img = images[index];
      if (!img || !img.classList.contains('zoom__image--magnified')) return;
      if (event.touches.length !== 1) return;
      img.classList.add('zoom__image--panning');
      glisse = { x: event.touches[0].clientX, y: event.touches[0].clientY, tx: tx, ty: ty };
    }, { passive: true });

    stage.addEventListener('touchmove', function (event) {
      var img = images[index];
      if (!glisse || !img) return;
      if (event.touches.length !== 1) return;
      // Le doigt déplace l'image d'autant : c'est le geste attendu, à l'inverse
      // du pilotage par position absolue utilisé à la souris.
      tx = glisse.tx + (event.touches[0].clientX - glisse.x);
      ty = glisse.ty + (event.touches[0].clientY - glisse.y);
      appliquer(img);
      event.preventDefault();
    }, { passive: false });

    stage.addEventListener('touchend', function () { glisse = null; });

    document.addEventListener('keydown', function (event) {
      if (zoom.hidden) return;

      if (event.key === 'Escape') fermer();
      if (event.key === 'ArrowLeft') afficher(index - 1);
      if (event.key === 'ArrowRight') afficher(index + 1);

      // Piège à focus : tant que la visionneuse est ouverte, la tabulation ne
      // doit pas repartir dans la page qui se trouve derrière.
      if (event.key === 'Tab') {
        var cibles = zoom.querySelectorAll('button');
        if (!cibles.length) return;
        var premier = cibles[0];
        var dernier = cibles[cibles.length - 1];

        if (event.shiftKey && document.activeElement === premier) {
          event.preventDefault();
          dernier.focus();
        } else if (!event.shiftKey && document.activeElement === dernier) {
          event.preventDefault();
          premier.focus();
        }
      }
    });
  }

  /* --- Préchargement à l'approche ---
     Cliquer une fiche produit laissait un temps mort : la page suivante n'était
     demandée qu'au clic, et son grand visuel seulement après. On met à profit
     les quelques centaines de millisecondes entre le moment où le curseur
     atteint un lien et celui où le doigt clique.

     Deux choses sont préparées : le HTML de la fiche, et son visuel principal.
     Ce dernier est déductible — la vignette et le grand format sont le MÊME
     fichier servi à deux largeurs, seul le paramètre change. */
  function initPrefetch() {
    var reseau = navigator.connection;
    // Ni sur une connexion lente, ni en mode économie de données : on y
    // gaspillerait le peu de débit disponible.
    if (reseau && (reseau.saveData || /2g/.test(reseau.effectiveType || ''))) return;

    var faits = {};
    var budget = 6;

    function preparer(lien) {
      var href = lien.getAttribute('href');
      if (!href || faits[href] || budget <= 0) return;
      faits[href] = true;
      budget--;

      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = href;
      document.head.appendChild(l);

      // Le grand visuel, déduit de la vignette.
      var vignette = lien.querySelector('img');
      if (!vignette) return;
      var src = vignette.currentSrc || vignette.src;
      if (!src || !/[?&]width=\d+/.test(src)) return;
      var grand = new Image();
      grand.src = src.replace(/([?&]width=)\d+/, '$11400');
    }

    document.querySelectorAll('a[href^="/products/"]').forEach(function (lien) {
      ['mouseenter', 'focus', 'touchstart'].forEach(function (evt) {
        lien.addEventListener(evt, function () { preparer(lien); }, { passive: true });
      });
    });
  }

  /* --- Accordéons PDP (Détails produit, Entretien, Retours…) --- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;

        var open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    });
  }

  /* --- Galerie PDP : pagination par points --- */
  function initProductGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;

    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var dots = gallery.querySelectorAll('[data-gallery-dot]');
    if (!slides.length) return;

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var i = Array.prototype.indexOf.call(slides, entry.target);
            dots.forEach(function (dot, j) {
              dot.setAttribute('aria-current', String(i === j));
            });
          });
        },
        { root: gallery, threshold: 0.6 }
      );

      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    }
  }

  /* --- En-tête immersif ---
     Au-dessus d'un visuel plein cadre, la colonne de gauche s'efface : fond
     transparent et entrées de menu masquées, seul le wordmark reste posé sur
     l'image. Dès qu'une section de contenu arrive sous la colonne, le menu
     revient. */
  function initImmersiveHeader() {
    var header = document.querySelector('.header');
    if (!header || header.dataset.immersive !== 'true') return;

    var medias = document.querySelectorAll('[data-immersive-media]');
    if (!medias.length) return;

    var nav = header.querySelector('[data-nav]');
    var ticking = false;

    /* Réveil au mouvement de la souris.

       Sans lui, la colonne reste invisible tant qu'on n'a pas défilé — et
       comme elle est invisible, rien n'indique où aller la chercher. Le
       moindre mouvement de souris la fait donc apparaître, puis elle
       s'efface à nouveau après quelques secondes d'immobilité, pour rendre
       au visuel son plein cadre.

       Réservé aux pointeurs fins : au doigt il n'y a pas de survol, et le
       menu mobile est de toute façon derrière le hamburger. */
    var eveille = false;
    var surLaColonne = false;
    var minuteur = null;
    var DELAI = 2500;

    function eveil(actif) {
      if (eveille === actif) return;
      eveille = actif;
      update();
    }

    function relancer() {
      clearTimeout(minuteur);
      // Tant que le curseur est SUR la colonne, elle ne s'efface pas : le
      // visiteur est en train de lire le menu ou de viser une entrée.
      minuteur = setTimeout(function () {
        if (!surLaColonne) eveil(false);
      }, DELAI);
    }

    // Hauteur de la bande de défilement sur laquelle la colonne se révèle.
    // Le fond et le menu ne basculent pas à un seuil : leur opacité suit la
    // position du visuel, pour que l'apparition soit continue.
    var BAND = 260;

    function update() {
      ticking = false;

      // Le menu ne s'efface qu'en desktop : sur mobile il est déjà replié
      // derrière le hamburger, et le panneau ouvert doit rester lisible.
      if (window.innerWidth < 990) {
        header.style.removeProperty('--header-reveal');
        header.classList.remove('header--immersive');
        return;
      }

      var headerRect = header.getBoundingClientRect();
      var probeY = nav ? nav.getBoundingClientRect().top : headerRect.top + 120;
      var probeX = headerRect.left + 20;
      var reveal = 1;

      Array.prototype.forEach.call(medias, function (media) {
        var r = media.getBoundingClientRect();

        // Le visuel doit couvrir la colonne horizontalement…
        if (r.left > probeX || r.right < probeX) return;
        // …et avoir déjà atteint la zone du menu. Sans ce test, un visuel
        // situé plus bas dans la page effacerait le menu par anticipation.
        if (r.top > probeY + BAND) return;

        var progress = (probeY + BAND - r.bottom) / BAND;
        reveal = Math.min(reveal, Math.max(0, Math.min(1, progress)));
      });

      // Deux opacités distinctes, et non une seule comme auparavant :
      //   --header-reveal  pilote le FOND blanc, et ne suit que le défilement.
      //                    C'est en descendant que le bloc se reconstitue.
      //   --header-text    pilote les ENTRÉES, et répond aussi à la souris.
      //                    Bouger la souris pose donc le texte nu sur le
      //                    visuel, sans bloc blanc derrière.
      var texte = eveille ? 1 : reveal;

      header.style.setProperty('--header-reveal', reveal.toFixed(3));
      header.style.setProperty('--header-text', texte.toFixed(3));
      // Le seuil ne sert qu'à neutraliser les clics sur un menu trop pâle :
      // il suit donc le texte, et non le fond.
      header.classList.toggle('header--immersive', texte < 0.5);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    if (window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('mousemove', function () {
        eveil(true);
        relancer();
      }, { passive: true });

      header.addEventListener('mouseenter', function () { surLaColonne = true; });
      header.addEventListener('mouseleave', function () {
        surLaColonne = false;
        relancer();
      });
    }

    update();
  }

  /* --- Fenêtre du guide des tailles (fiche produit) ---
     Presque tout est fourni par <dialog> : piège à focus, fermeture par Échap,
     inertie de la page derrière. Il ne reste ici que l'ouverture, le clic sur
     le fond, et le blocage du défilement du corps — que `showModal` ne fait
     pas de lui-même. */
  function initSizeGuide() {
    var fenetre = document.querySelector('[data-size-guide]');
    var ouverture = document.querySelector('[data-size-guide-open]');
    if (!fenetre || !ouverture || !fenetre.showModal) return;

    // Même règle que la visionneuse : la modalité est retenue À L'OUVERTURE.
    // Sans cela, fermer par Échap après un clic souris rendrait le focus au
    // déclencheur en dessinant son anneau, que le visiteur lit comme un défaut.
    var ouvertAuClavier = false;

    ouverture.addEventListener('click', function () {
      ouvertAuClavier = auClavier;
      fenetre.showModal();
      document.body.classList.add('zoom-open');
    });

    var fermeture = fenetre.querySelector('[data-size-guide-close]');
    if (fermeture) fermeture.addEventListener('click', function () { fenetre.close(); });

    // Clic sur le fond. L'événement vise alors le <dialog> lui-même : tout clic
    // à l'intérieur du contenu vise un de ses descendants.
    fenetre.addEventListener('click', function (event) {
      if (event.target === fenetre) fenetre.close();
    });

    // `close` couvre les trois sorties — bouton, fond, touche Échap.
    fenetre.addEventListener('close', function () {
      document.body.classList.remove('zoom-open');
      if (!ouvertAuClavier) ouverture.blur();
    });
  }

  /* --- Diaporama de campagne --- */
  function initSlideshow() {
    document.querySelectorAll('[data-slideshow]').forEach(function (slideshow) {
      var slides = slideshow.querySelectorAll('[data-slide]');
      var dots = slideshow.querySelectorAll('[data-slide-dot]');
      if (slides.length < 2) return;

      var index = 0;
      var timer = null;

      function show(next) {
        index = (next + slides.length) % slides.length;

        slides.forEach(function (slide, i) {
          slide.dataset.active = String(i === index);
        });

        dots.forEach(function (dot, i) {
          dot.setAttribute('aria-current', String(i === index));
        });
      }

      // Une personne qui a demandé moins d'animations ne doit pas subir
      // un défilement automatique.
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var interval = Number(slideshow.dataset.interval) || 7000;
      var autoplay = slideshow.dataset.autoplay === 'true' && !reducedMotion;

      function start() {
        if (!autoplay || timer) return;
        timer = setInterval(function () {
          show(index + 1);
        }, interval);
      }

      function stop() {
        clearInterval(timer);
        timer = null;
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          stop();
          show(i);
        });
      });

      // Pas d'animation en arrière-plan : inutile et coûteux en batterie.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      slideshow.addEventListener('mouseenter', stop);
      slideshow.addEventListener('mouseleave', start);
      slideshow.addEventListener('focusin', stop);

      start();
    });
  }

  function init() {
    watchHeaderHeight();
    watchAnnouncement();
    initSlideshow();
    initImmersiveHeader();
    initNav();
    initAccordions();
    initPrefetch();
    initProductGallery();
    initZoom();
    initSizeGuide();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
